import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function CTASection({ eyebrow = "Ready to start?", title = "Get a tailored facilities maintenance proposal.", subtitle = "Tell us about your facility — we'll deliver a quote and capability statement within one business day." }) {
  return (
    <section data-testid="cta-section" className="bg-[var(--es-navy)] text-white es-grain relative overflow-hidden">
      <div className="es-container py-16 md:py-24 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[var(--es-accent)] mb-3">{eyebrow}</div>
          <h2 className="es-h2 text-white">{title}</h2>
          <p className="mt-4 text-white/75 max-w-2xl">{subtitle}</p>
        </div>
        <div className="md:col-span-4 flex md:justify-end gap-3 flex-wrap">
          <Link to="/quote" data-testid="cta-quote-button" className="es-btn-accent">Request a Quote <ArrowRight size={18} /></Link>
          <Link to="/contact" data-testid="cta-contact-button" className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white text-white px-6 py-3 font-semibold rounded-sm transition-all">Contact Us</Link>
        </div>
      </div>
    </section>
  );
}
